import { FilterConditionProp } from "../pages/layout/Query/FilterCondition";
import { FilterFormulaProp } from "../pages/layout/Query/FilterFormula";

export interface Query {
  name: string;
  cubeName: string;
  axes: { ROWS: string[]; COLUMNS: string[] };
  enhancedFilterCriteria: any;
  properties: {
    subType: string;
  };
  gridSorts: GridSort[];
  owner: string;
  filterLevel?: string;
}

export interface GridSort {
  colId: string;
  sort: string;
  levelUniqueName: string;
  sortIndex: number;
}

export interface Result {
  activeIndex: number;
  query: Query;

  result: {
    headers: any[];
    rows: [any];
    resultFill: string;
    mergeCount: {};
    queryRuntime: {
      rows: number;
      cols: number;
    };
  };
  history: [];
  status: string;
  progress: string;
  uid: string;
  activeQueryDetail: {
    queryMode: string;
  };
  availableOptions: string[];
}

export interface QueryState {
  query: Query | null;
  results: Result | null;
  loading: boolean;
  error: string | null;
  isUpdatedTab: boolean;
  queryMode: string;
  querySubType: string | null;
  msrSelections: string[] | null;
  isQueryUpdated: boolean;
  isNewQuery: boolean;
  resetGrpFn?: boolean;
  axesWithAllSelected?: string[] | null;
  currentQueryIndex: number;
  historyCount: number;
  currentQueryType: string;
  isSourceHistory: boolean;
  isLoadQueryMode: boolean;
  tabName: string;
  tabOrder: number;
  isSavedQueryLoaded: boolean;
  isLoadingQuery: boolean;
  isSavingQuery: boolean;
  updatedNamedsetList: Record<string, string[]>;
}

export interface InitialQueryState {
  queries: QueryState[];
  currentTabIndex: number;
  loadQueryIds: any[];
  isLoadingSavedQueries: boolean;
  currUpdatingTabIndex: number;
}
export interface filterSelectionsType {
  selectedFilters: {
    name: string;
    isNamedSet?: boolean;
    selType?: string;
  }[];
  exclude: boolean;
  isAllSelected?: boolean;
  applyTo: string | null;
  isForNamedSet?: boolean;
  condition?: FilterConditionProp;
  formula?: FilterFormulaProp;
}

export interface FilterBoxSelections {
  selectedFilters: TimeFilterOption[];
  exclude: boolean;
  applyTo: string | null;
}

export const defaultFilterSelections: filterSelectionsType = {
  selectedFilters: [],
  exclude: false,
  applyTo: null,
  condition: { type: "", value: "", exclude: false },
};

export const defaultTimePeriodFilterSelections: filterSelectionsType = {
  selectedFilters: [],
  exclude: false,
  applyTo: null,
};

export interface LevelNode {
  uniquename: string;
  name: string;
  properties?: any;
  caption?: string;
  levels: LevelNode[];
}

export interface TreeNode {
  levels: LevelNode[];
  name: string;
  caption?: string;
  uniquename?: string;
  properties?: any;
  memberCount?: number;
}

export interface FilterLayoutProps {
  treeData: TreeNode;
  activePanelTab: string;
  filterSelections: filterSelectionsType;
  applyFilter: (item: filterSelectionsType, datatype: string) => void;
}

export interface FilterBoxProps {
  treeData: TreeNode;
  filterSelections: filterSelectionsType;
  applyFilter: (item: filterSelectionsType, datatype: string) => void;
  advancedFilterGridRef: React.RefObject<any>;
  advancedFilterGridColumn?: any;
  handleCheckAll?: () => void;
  handleUncheckAll?: () => void;
  setIsNameSetListMode: (isNameSetListMode: boolean) => void;
  onRowSelected?: (event: any) => void;
  onCellClicked?: (event: any) => void;
  selectRowsByArray: (rows: any[]) => void;
  currentSelections: any[];
  setExclude?: React.Dispatch<React.SetStateAction<boolean>>;
  isExclude?: boolean;
  selectRowsByCurrentSelections?: () => void;
  clearSelections?: () => void;
  setOptionsLength?: any;
  activePanelTab: string;
  onEditNamedSet?: (namedSet: any) => void;
  onNamedSetListChange?: (namedSets: TimeFilterOption[]) => void;
}

export interface FilterOption {
  name: string;
  caption: string;
  uniqueName: string;
}

export interface SavedQueryGroup {
  id?: number;
  name: string;
  description: string;
  savedQueryList: {
    queryId?: number;
    olapQueryName: string;
    name: string;
    description: string;
    isShared: boolean;
    isFlattenedView: boolean;
    type: string;
    subType?: string;
    gridSorts: GridSort[];
    mapOptions?: { measureSelections: string[] };
  }[];
}

export interface TimeFilterOption {
  name: string;
  caption: string;
  altCaption: String;
  uniqueName: string;
  isNamedSet?: boolean;
  selType?: string;
  properties: {};
}

export interface TimeCategoryOption {
  name: string;
  ord: number;
  isMember: (member: any) => boolean;
}
